import { z } from 'zod';
// Принимаем любой непустой идентификатор — email или телефон. Конкретный
// разбор (email / нормализация телефона) делается на бэке и на фронте.
export const LoginRequestSchema = z.object({
    identifier: z.string().trim().min(3).max(200),
    password: z.string().min(8).max(200),
});
export const UserRoleSchema = z.enum(['TUTOR', 'ADMIN', 'STUDENT']);
export const UserDtoSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    phone: z.string().nullable(),
    name: z.string(),
    role: UserRoleSchema,
});
export const LoginResponseSchema = z.object({
    accessToken: z.string(),
    user: UserDtoSchema,
});
//# sourceMappingURL=auth.js.map